const PRODUCTION_APP_HOST = "suvi.health";

function normalizedHostname(hostname: string): string {
  return hostname.trim().toLowerCase().replace(/\.$/, "");
}

/**
 * Whether a public hostname may promote the production store app.
 *
 * Non-production landers hand off only to the approved internal dev-client
 * distribution and must never emit store metadata or links. Exact apex matching
 * keeps every subdomain, care-team host, and unrelated host fail-closed.
 */
export function isNativeAppPromotionEligibleHost(deploymentHostname: string): boolean {
  return normalizedHostname(deploymentHostname) === PRODUCTION_APP_HOST;
}

export type NativeAppHandoff =
  | {
      readonly kind: "store";
      readonly iosAppStoreUrl: string;
      readonly androidPlayStoreUrl: string;
    }
  | { readonly kind: "internal-dev-client" };

/** Resolve the post-claim handoff without exposing store URLs on non-production hosts. */
export function resolveNativeAppHandoff(
  deploymentHostname: string,
  iosAppStoreUrl: string,
  androidPlayStoreUrl: string,
): NativeAppHandoff {
  return isNativeAppPromotionEligibleHost(deploymentHostname)
    ? { kind: "store", iosAppStoreUrl, androidPlayStoreUrl }
    : { kind: "internal-dev-client" };
}
